import React, { Component } from 'react'

class LightBox extends Component {

  static defaultProps = {
    active: false,
    closeFunc: () => {},
  }

  render() {
    const { active, closeFunc } = this.props

    let btnProps = {
      type: 'button',
      className: 'lightbox__close',
      onClick: closeFunc,
    }

    return (
      <div className={`lightbox ${active ? 'lightbox--active' : ''}`}>
        <div className='lightbox__inner'>
          <div>
            <button {...btnProps}>
              Close
            </button>
            { this.props.children }
          </div>
        </div>
      </div>
    )
  }
}

export default LightBox
